// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"ModalWrapper_wrapper__5U4xv","modalOverlay":"ModalWrapper_modalOverlay__eODkX","fadeIn":"ModalWrapper_fadeIn__dYdFR","tall":"ModalWrapper_tall__doYmA"};